import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  Stack
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
} from '@mui/icons-material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: (theme) => theme.palette.grey[900],
        color: 'white',
        py: 6,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              MekaSys
            </Typography>
            <Typography variant="body2" paragraph>
              Sistema de gestión integral para talleres mecánicos
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Enlaces
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link component={RouterLink} to="/" color="inherit" underline="hover" sx={{ display: 'inline-block', mb: 1 }}>
                  Inicio
                </Link>
              </li>
              <li>
                <Link component={RouterLink} to="/precios" color="inherit" underline="hover" sx={{ display: 'inline-block', mb: 1 }}>
                  Planes y Precios
                </Link>
              </li>
            </ul>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Legal
            </Typography>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>
                <Link component={RouterLink} to="/terminos" color="inherit" underline="hover" sx={{ display: 'inline-block', mb: 1 }}>
                  Términos y Condiciones
                </Link>
              </li>
              <li>
                <Link component={RouterLink} to="/privacidad" color="inherit" underline="hover" sx={{ display: 'inline-block', mb: 1 }}>
                  Política de Privacidad
                </Link>
              </li>
            </ul>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Contacto
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Box sx={{ display: 'flex', mb: 2 }}>
                <EmailIcon sx={{ mr: 1 }} />
                <Typography variant="body2">
                  <Link href="mailto:contacto@mekasys.info" color="inherit" underline="hover">
                    contacto@mekasys.info
                  </Link>
                </Typography>
              </Box>
              <Box sx={{ display: 'flex' }}>
                <PhoneIcon sx={{ mr: 1 }} />
                <Typography variant="body2">+56932647638</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ borderTop: 1, borderColor: 'grey.700', mt: 4, pt: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            © {currentYear} MekaSys. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 